export default __webpack_public_path__ + "static/media/nasa.08dafbe9.png";